export { default } from './SearchInputTw';
